import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, TextField, IconButton } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import SortingElement from './SortingElement';
import { SortableContainer, arrayMove } from 'react-sortable-hoc';

const useStyles = makeStyles(theme => ({
  container: {
    width: '90%',
    maxWidth: '600px',
    padding: '20px',
    marginTop: '20px',
    marginInline: 'auto',
    borderWidth: 2,
    borderColor: theme.palette.grey[400],
    borderStyle: 'dashed',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  contentContainer: {
    width: '100%',
    maxWidth: '400px',
    marginInline: 'auto',
    borderTopWidth: 1,
    borderTopColor: theme.palette.grey[400],
    borderTopStyle: 'solid',
    paddingTop: '20px',
  },
  adderContainer: {
    width: '100%',
    maxWidth: '400px',
    marginInline: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      border: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
}));

export default function SortingContainer({ items, setItems }) {
  const [currVal, setCurrVal] = useState();
  const classes = useStyles();

  const handleAdd = () => {
    if (currVal) {
      let itemsCopy = [...items];
      itemsCopy.push(currVal);
      setCurrVal('');
      setItems(itemsCopy);
    }
  };

  const handleRemove = index => {
    let itemsCopy = [...items];
    itemsCopy = itemsCopy.filter((items, i) => i !== index);
    setItems(itemsCopy);
  };

  const ItemsList = SortableContainer(({ allItems }) => {
    return (
      <Box className={classes.contentContainer}>
        {allItems.map((item, index) => (
          <SortingElement title={item} key={index} index={index} handleDelete={() => handleRemove(index)} />
        ))}
      </Box>
    );
  });

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setItems(arrayMove(items, oldIndex, newIndex));
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.adderContainer}>
        <TextField
          variant="outlined"
          className={classes.input}
          value={currVal}
          type={'text'}
          placeholder="مورد خود را اینجا وارد کنید"
          onChange={e => setCurrVal(e.target.value)}
        />
        <IconButton size="medium" onClick={handleAdd}>
          <Add />
        </IconButton>
      </Box>
      <ItemsList allItems={items} onSortEnd={onSortEnd} useDragHandle={true} />
    </Box>
  );
}
